/**
 * Find the next index in the list where the item is not yet complete.
 */
export function getNextIncompleteIndex(items, fromIndex, isComplete) {
  for (var i = fromIndex + 1; i < items.length; i++) {
    if (!isComplete(items[i])) return i;
  }
  return -1;
}

/**
 * Derive current step phase from progress (transverse done -> longitudinal, both -> submit).
 */
export function getPhaseFromProgress(progress) {
  if (progress !== null && progress !== void 0 && progress.transverse && !(progress !== null && progress !== void 0 && progress.longitudinal)) return "longitudinal";
  return "transverse";
}